export default "__VITE_ASSET__BJwkxH3t__"